<template>
  <van-dialog width="295" v-model="visible" title="您已注册成功" :showConfirmButton="false">
            <div class="customer-dialog">
                <van-icon class="customer-dialog-close" name="cross" @click="btnClickClose" />
                <div class="customer-dialog-desc">
                    为了方便沟通后期事宜，可加博医荟助手的微信
                </div>
                <img src="/static/img/430.jpeg" alt="" />
                <div class="customer-dialog-tip">请长按识别添加</div>
            </div>
        </van-dialog>
</template>

<script>
export default {
    name: 'customerDialog',
    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    watch: {
        show: {
            handler(val) {
                this.visible = val
            },
            immediate: true
        },
    },
    data() {
        return {
            visible: false,
        }
    },
    methods: {
        btnClickClose() {
            this.$emit('update:show',false)
            this.$emit('close')
        }
    },
    created() {
    }
}
</script>

<style scoped lang="scss">

.customer-dialog {
        text-align: center;
        padding: 0 20px 40px;
        &-close {
            position: absolute;
            right: 0;
            top: 0;
            padding: 12px;
            color: #c8c9cc;
            font-size: 22px;
        }
        img {
            display: block;
            margin: 40px auto 0;
            width: 120px;
            height: 120px;
        }
        &-desc {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #7c7d81;
            letter-spacing: 1px;
            margin-top: 12px;
            text-align: left;
        }
        &-tip {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #7c7d81;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/login/add-info/components/customerDialog.vue